import { useEffect, useRef } from "react";
import $ from "jquery";
import "daterangepicker";
import "daterangepicker/daterangepicker.css";
import moment from "moment";

const DISPLAY_FORMAT = "DD/MM/YYYY";
const VALUE_FORMAT = "YYYY-MM-DD";
const AUTOCLOSE_MS = Number(process.env.REACT_APP_DATEPICKER_AUTOCLOSE_MIN || 5) * 60 * 1000;

const parseDate = (value) => {
  if (!value) return null;
  const parsed = moment(value, [VALUE_FORMAT, DISPLAY_FORMAT], true);
  return parsed.isValid() ? parsed : null;
};

export const CustomSingleDatePicker = ({
  value,
  onChange,
  minDate = null,
  maxDate = null,
  placeholder = "",
  disabled = false,
}) => {
  const inputRef = useRef(null);
  const autoCloseRef = useRef(null);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEffect(() => {
    const $input = $(inputRef.current);

    $input.daterangepicker({
      singleDatePicker: true,
      autoApply: true,
      autoUpdateInput: false,
      showDropdowns: true,
      opens: "center",
      drops: "auto",
      startDate: parseDate(value) || moment(),
      locale: { format: DISPLAY_FORMAT },
    });

    const picker = $input.data("daterangepicker");
    picker.container.addClass("wes-dateRange-drop wes-singleDate-drop");

    $input.on("apply.daterangepicker", function (ev, p) {
      $(this).val(p.startDate.format(DISPLAY_FORMAT));
      onChangeRef.current?.(p.startDate.format(VALUE_FORMAT));
    });

    $input.on("show.daterangepicker", () => {
      clearTimeout(autoCloseRef.current);
      autoCloseRef.current = setTimeout(() => picker.hide(), AUTOCLOSE_MS);
    });

    $input.on("hide.daterangepicker", () => {
      clearTimeout(autoCloseRef.current);
    });

    return () => {
      clearTimeout(autoCloseRef.current);
      if ($input.data("daterangepicker")) {
        $input.data("daterangepicker").remove();
      }
    };
  }, []);

  useEffect(() => {
    const $input = $(inputRef.current);
    const picker = $input.data("daterangepicker");
    if (!picker) return;

    const parsed = parseDate(value);
    $input.val(parsed ? parsed.format(DISPLAY_FORMAT) : "");
    if (parsed) {
      picker.setStartDate(parsed);
      picker.setEndDate(parsed);
    }
  }, [value]);

  useEffect(() => {
    const picker = $(inputRef.current).data("daterangepicker");
    if (!picker) return;

    picker.minDate = parseDate(minDate) || false;
    picker.maxDate = parseDate(maxDate) || false;
    if (picker.isShowing) {
      picker.updateView();
    }
  }, [minDate, maxDate]);

  useEffect(() => {
    const $input = $(inputRef.current);
    const picker = $input.data("daterangepicker");

    $input.prop("disabled", disabled);
    if (disabled && picker) {
      picker.hide();
    }
  }, [disabled]);

  return (
    <div className={`catalog-dateSearch${disabled ? " is-disabled" : ""}`}>
      <input ref={inputRef} type="text" className="form-control" placeholder={placeholder} readOnly autoComplete="off" />
      <span>
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M6 1.5V3.75" stroke="#606060" strokeLinecap="round" />
          <path d="M12 1.5V3.75" stroke="#606060" strokeLinecap="round" />
          <path d="M2.625 6.81641H15.375" stroke="#606060" strokeLinecap="round" />
          <path
            d="M15.75 6.375V12.75C15.75 15 14.625 16.5 12 16.5H6C3.375 16.5 2.25 15 2.25 12.75V6.375C2.25 4.125 3.375 2.625 6 2.625H12C14.625 2.625 15.75 4.125 15.75 6.375Z"
            stroke="#606060"
          />
        </svg>
      </span>
    </div>
  );
};
